// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__JOLbI","user":"FAQ_user__hTlxQ","list":"FAQ_list__skWRy","card":"FAQ_card__L2XeZ","answer":"FAQ_answer__eom0+"};